const updatePrivacyField = (target, isPrivate) => {
  const privacy = typeof isPrivate !== "undefined" ? isPrivate && "private" || "public" : void 0;
  target.privacy = privacy;
};

export { updatePrivacyField };
//# sourceMappingURL=utils.js.map
